<template>
  <div class="preshipping-feedback-modal-content">
    <h3 class="no-margin very-small-margin-bottom border-bottom" v-if="preshippingFeedback.length">Sneak Peek Feedback</h3>
    <h3 class="no-margin very-small-margin-bottom" v-else>No Sneak Peek feedback is given</h3>

    <div class="row flex flex-column small-margin-bottom">
      <h5 v-if="preshippingComment" class="very-small-margin-bottom very-small-margin-top">What the customer feels is missing in the box </h5>
      <textarea v-if="preshippingComment" v-model="preshippingComment.comment" readonly></textarea>
    </div>

    <div class="products-wrapper flex flex-wrap justify-content-center">
      <div v-for="el in feedbacks" :key="el.product_id" class="very-small-margin" style="max-width: 160px;">
        <product
          :product="el.product"
          :in-box="true"
          :feedback="el.accepted ? 'heart' : 'close'"
          :feedbackReason="el.name"
        />
        <div v-if="el.comment" class="flex flex-column small-padding-left small-margin-right small-padding-top">
          <h5 class="no-margin">Customer commented: </h5>
          <p class="no-margin">{{ el.comment }}</p>
        </div>
      </div>
    </div>

    <div class="divider sa"></div>

    <h3 class="small-margin-bottom border-bottom">Quiz Feedback</h3>
    <div class="quiz-wrapper flex" v-if="preshippingQuizFeedback">
      <div class="quiz-categories flex flex-column">
        <span>In need of:</span>
        <div class="flex flex-wrap">
          <span class="category-icon flex justify-center align-center relative" v-for="category in preshippingQuizFeedback.selected_categories" :key="category.id">
            <img :src="`${storage_url}${category.image}`" :alt="category.name">
            <span class="category-name">{{ category.name }}</span>
          </span>
        </div>
      </div>
      <div class="quiz-products flex flex-wrap">
        <div class="very-small-margin" v-for="product in preshippingQuizFeedback.liked_to_box" :key="product.product_id">
          <product
            :product="product.product"
            :in-box="true"
            :feedback="'heart'"
          />
        </div>
        <div class="very-small-margin" v-for="product in preshippingQuizFeedback.liked" :key="product.product_id">
          <product
            :product="product.product"
            :in-box="true"
            :feedback="'star'"
          />
        </div>
        <div class="very-small-margin" v-for="product in preshippingQuizFeedback.dislike" :key="product.product_id">
          <product
            :product="product.product"
            :in-box="true"
            :feedback="'close'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Product from './Product'
export default {
  name: 'PreshippingFeedbackModal',

  components: {
    Product
  },

  props: {
    preshippingFeedback: {
      type: Array,
      default: () => []
    },
    preshippingComment: {
      type: Object,
      default: null
    },
    preshippingQuizFeedback: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      storage_url: process.env.VUE_APP_CDN_BASE_URL
    }
  },
  computed: {
    feedbacks () {
      return this.preshippingFeedback.map(feedback => ({
        ...feedback,
        product: {
          ...feedback.product,
          variants: Object.values(feedback.product.variants)[0]
        }
      })).sort((a, b) => b.accepted - a.accepted)
    }
  }
}
</script>

<style lang="less" scoped>

.preshipping-feedback-modal-content{
    .product-wrapper{
        @media screen and (max-width: 1700px) {
            max-height: 250px;
        }
    }
}
.border-bottom {
  border-bottom: 2px solid;
}

/deep/.product-wrapper {
  // make product card smaller on preshipping modal
  width: 160px;
  height: 230px;
  font-size: 12px;

  .img-thumbnail {
    height: 50%;
  }

  .svg-icon {
    transform: scale(.7);
    transform-origin: top left;
  }
}

.divider {
  height: 2px;
}

.quiz-wrapper {
  .quiz-categories {
    width: 27%;
    margin-right: 20px;

    .category-icon {
      width: 60px;
      height: 80px;
      margin: 3px 10px;
      text-align: center;
      padding: 5px;
      border: 1px solid #FDADA6;

      img {
        max-width: 100%;
        max-height: 100%;
      }

      .category-name {
        position: absolute;
        width: 100%;
        font-weight: 500;
        opacity: .6;
      }
    }
  }

  .quiz-products {
    .quiz-product {
      width: 120px;
      text-align: center;
      position: relative;

      img {
        max-width: 100%;
      }
    }
  }
}
</style>
